module.exports = __webpack_public_path__ + "kedar-b132c40c35d9dddb1739.jpeg";